import type { PublicWeComError } from "../shared/types.js";

export function extractRejectedIp(message: string | null | undefined): string | null {
  if (!message) {
    return null;
  }

  return message.match(/from ip:\s*([0-9a-fA-F:.]+)/i)?.[1] ?? null;
}

export function isWeComIpRejected(errcode: number | null | undefined, message: string | null | undefined): boolean {
  return errcode === 60020 || /not allow to access from your ip/i.test(message ?? "");
}

export function mapOAuthErrorMessage(oauthError: string, wecomErrcode: number | null): string {
  if (oauthError === "invalid_state") {
    return "OAuth 会话已失效，请重新发起授权。";
  }

  if (oauthError === "wecom_api" && wecomErrcode === 60020) {
    return "企业微信接口拒绝当前服务器出口 IP，当前无法获取成员身份或 JS-SDK Ticket。";
  }

  if (oauthError === "wecom_api") {
    return "企业微信接口调用失败，请查看服务器诊断信息。";
  }

  return "OAuth 回调失败，请重新发起授权。";
}

export function getPublicErrorMessage(error: PublicWeComError | null | undefined, fallback: string): string {
  return error?.wecomErrMsg || error?.message || fallback;
}
